module.exports = __webpack_public_path__ + "static/img/pic08.102dbd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunkang/pic08.png
// module id = lvzp
// module chunks = 2